import { render, staticRenderFns } from "./remarkInfo.vue?vue&type=template&id=015af8e4&scoped=true&"
import script from "./remarkInfo.vue?vue&type=script&lang=js&"
export * from "./remarkInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015af8e4",
  null
  
)

export default component.exports